module.exports = __webpack_public_path__ + "static/img/nigong4.f8466ff0.jpg";